<template>
  <div class="content-v2">
    <div class="business-head">
      <span>SERVICES</span>
      <h2>{{ $t('common.business') }}</h2>
      <p>围绕电力工程全流程，形成调试、维护、检修、试验、运行与实验室协同服务能力。</p>
    </div>
    <div class="business-grid">
      <router-link class="business-card" v-for="item in displayBusinessList" :key="item.id" :to="`/about/business/${item.id}`">
        <div class="business-image">
          <img :src="item.image" :alt="item.deptName" />
        </div>
        <div class="business-body">
          <span>{{ item.deptName }}</span>
          <h3>{{ item.title }}</h3>
          <p>{{ item.content }}</p>
          <strong>查看详情 →</strong>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
import { getBusinessList } from '@/api/portal'
import { resolveFileUrl } from '@/utils/request'
import imageA from '@/assets/images/banner2.svg'
import imageB from '@/assets/images/case1.svg'
import imageC from '@/assets/images/case2.svg'
import imageD from '@/assets/images/banner3.svg'
import imageE from '@/assets/images/banner4.svg'
import imageF from '@/assets/images/banner5.svg'

const fallbackBusiness = [
  {
    id: 'debug',
    deptName: '调试',
    title: '电力调试服务',
    content: '面向火电、新能源、生物质、垃圾发电、燃机等项目，提供分系统调试、整套启动调试及并网前后技术支持。',
    image: imageA
  },
  {
    id: 'maintain',
    deptName: '维护',
    title: '设备维护与运行保障',
    content: '围绕设备状态、运行数据和现场缺陷，开展计划维护、巡检消缺、技术监督和稳定运行保障。',
    image: imageB
  },
  {
    id: 'overhaul',
    deptName: '检修',
    title: '机组检修与专项治理',
    content: '承接火电、新能源及综合能源项目检修任务，覆盖设备检修、系统治理、隐患排查和质量验收。',
    image: imageC
  },
  {
    id: 'test',
    deptName: '电力试验',
    title: '性能试验与设备检测',
    content: '提供性能试验、热力试验、保护定值计算、设备健康检测等技术服务，为项目安全经济运行提供依据。',
    image: imageD
  },
  {
    id: 'operation',
    deptName: '运行',
    title: '电厂托管与运行服务',
    content: '面向电厂托管运营和项目运行需求，提供运行组织、制度建设、岗位培训和现场管理支持。',
    image: imageE
  },
  {
    id: 'lab',
    deptName: '油化实验室',
    title: '油化检测与实验分析',
    content: '围绕绝缘油、汽水品质、化学监督等方向开展检测分析，支撑设备健康评价和运行风险控制。',
    image: imageF
  }
]

export default {
  name: 'AboutBusinessV2',
  data() {
    return {
      businessList: fallbackBusiness
    }
  },
  created() {
    getBusinessList().then(list => {
      if (!list || !list.length) {
        return
      }
      this.businessList = list.map((item, index) => ({
        id: item.businessId,
        deptName: item.deptName,
        title: item.introTitle,
        content: item.introContent,
        image: resolveFileUrl(item.imageUrl, fallbackBusiness[index % fallbackBusiness.length].image)
      }))
    }).catch(() => {})
  },
  computed: {
    displayBusinessList() {
      return this.businessList
    }
  }
}
</script>

<style lang="scss" scoped>
.business-head {
  max-width: 760px;
  margin-bottom: 36px;

  span {
    color: #2563eb;
    font-size: 13px;
    font-weight: 800;
    letter-spacing: 4px;
  }

  h2 {
    margin: 10px 0 12px;
    font-size: 34px;
    color: #0f172a;
  }

  p {
    margin: 0;
    font-size: 16px;
    line-height: 1.8;
    color: #64748b;
  }
}

.business-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 26px;
}

.business-card {
  background: #fff;
  border: 1px solid #dbe7f5;
  color: inherit;
  display: grid;
  grid-template-columns: 220px minmax(0, 1fr);
  min-height: 220px;
  overflow: hidden;
  box-shadow: 0 18px 45px rgba(15, 23, 42, 0.06);
  text-decoration: none;
  transition: transform 0.25s ease, box-shadow 0.25s ease;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 24px 55px rgba(15, 23, 42, 0.1);
  }
}

.business-image {
  background: #e2e8f0;

  img {
    width: 100%;
    height: 100%;
    min-height: 220px;
    display: block;
    object-fit: cover;
  }
}

.business-body {
  padding: 28px;

  span {
    display: inline-flex;
    align-items: center;
    height: 28px;
    padding: 0 12px;
    color: #1d4ed8;
    background: #eff6ff;
    font-size: 13px;
    font-weight: 700;
  }

  h3 {
    margin: 18px 0 12px;
    font-size: 22px;
    color: #0f172a;
  }

  p {
    margin: 0;
    font-size: 15px;
    line-height: 1.9;
    color: #475569;
  }

  strong {
    display: inline-flex;
    margin-top: 18px;
    color: #2563eb;
    font-size: 14px;
    font-weight: 700;
  }
}

@media (max-width: 1100px) {
  .business-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 720px) {
  .business-card {
    grid-template-columns: 1fr;
  }
}
</style>
